export default __webpack_public_path__ + "static/media/hands_on_hips.4947e6d8.png";